import React from "react";
import "../../css/App.css";
import themeLarge from "../ThemeLarge";
import { FaRegCalendarAlt } from "react-icons/fa";
import { FcReading } from "react-icons/fc";
import { IoMdShare } from "react-icons/io";
import { FaCopy, FaFacebook, FaLinkedin, FaXTwitter } from "react-icons/fa6";
import { showNotification } from "../../uti";

class BlogTitleView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showShareOptions: false,
    };
  }

  toggleShareOptions = () => {
    this.setState((prevState) => ({
      showShareOptions: !prevState.showShareOptions,
    }));
  };

  copyLinkToClipboard = () => {
    navigator.clipboard.writeText(window.location.href);
    showNotification("Link copied to clipboard!", "info", 5000);
  };

  closeShareOptions = () => {
    this.setState({ showShareOptions: false });
  };

  render() {
    const { title, subtitle, minutesToRead, createdAt } = this.props;
    const { showShareOptions } = this.state;

    const shareUrl = window.location.href;
    const shareText = `Read this blog by Ibtehaz: ${title}`;

    return (
      <div className="container ">
        <p
          className="mt-5 d-flex justify-content-center align-items-center"
          style={{
            fontFamily: "Merriweather",
            fontSize: themeLarge.fontSize.h1,
            color: themeLarge.colors.text,
            fontWeight: "700",
          }}
        >
          {title}
        </p>
        <p
          style={{
            fontFamily: "Kumbh Sans",
            fontSize: themeLarge.fontSize.h4,
          }}
        >
          {subtitle}
        </p>

        <hr />

        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            gap: "20px",
            marginTop: "20px",
            marginBottom: "20px",
            fontSize: themeLarge.fontSize.body,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <FcReading />
            <span>{minutesToRead} min read</span>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <FaRegCalendarAlt />
            <span>{createdAt}</span>
          </div>

          <div style={{ position: "relative" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
                cursor: "pointer",
              }}
              onClick={this.toggleShareOptions}
            >
              <IoMdShare />
              <span>Share</span>
            </div>

            {showShareOptions && (
              <div
                className="share-options"
                style={{
                  position: "absolute",
                  transform: "none", // Center it
                  marginTop: "10px",
                  backgroundColor: "#fff",
                  border: "1px solid #ddd",
                  borderRadius: "6px",
                  padding: "10px",
                  zIndex: 9999,
                  boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                  whiteSpace: "nowrap",
                  maxWidth: "90vw", // Prevent overflow on mobile
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    fontSize: "16px",
                  }}
                >
                  <button
                    onClick={() => {
                      this.copyLinkToClipboard();
                      this.closeShareOptions();
                    }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                    className="btn btn-light"
                  >
                    <FaCopy />
                    Copy Link
                  </button>

                  <a
                    href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
                      shareUrl
                    )}`}
                    onClick={this.closeShareOptions}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-light d-flex align-items-center gap-2"
                  >
                    <FaLinkedin />
                    Share on LinkedIn
                  </a>

                  <a
                    href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                      shareUrl
                    )}`}
                    onClick={this.closeShareOptions}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-light d-flex align-items-center gap-2"
                  >
                    <FaFacebook />
                    Share on Facebook
                  </a>

                  <a
                    href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
                      shareUrl
                    )}&text=${encodeURIComponent(shareText)}`}
                    onClick={this.closeShareOptions}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-light d-flex align-items-center gap-2"
                  >
                    <FaXTwitter />
                    Share on X
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>

        <hr />
      </div>
    );
  }
}

export default BlogTitleView;
